import { render, staticRenderFns } from "./fullPrice.vue?vue&type=template&id=1fc59af4&"
import script from "./fullPrice.vue?vue&type=script&lang=js&"
export * from "./fullPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports